import { ElMessage, ElMessageBox } from '@pit-element-plus/components'
import type { MessageType } from '@pit-element-plus/components'

export function useMessageBox(msg = '是否删除已选中数据？') {
  return new Promise<void>((resolve, rejects) => {
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      closeOnClickModal: false,
    })
      .then(() => resolve())
      .catch(() => rejects())
  })
}

export function useMessage(
  message = '系统错误，请联系管理员',
  type: MessageType = 'success'
) {
  return new Promise<void>((resolve) => {
    ElMessage({
      type,
      message: message ? message : '系统错误，请联系管理员',
      onClose: () => resolve(),
    })
  })
}
